import { useMemo } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { atomWithMutation } from 'jotai-tanstack-query';
import { toolDefinitionService } from '@/services';
import { selectedBusinessUnitIdAtom } from '@/stores/business-unit.store';

/** One atom per tool and brand, so a run's answer never shows on another tool's Test tab or under another brand. */
const runToolMutationAtom = (provider: string, tool: string, buId: string | null) =>
  atomWithMutation(() => ({
    mutationKey: ['tool-definitions', 'run', provider, tool, buId],
    mutationFn: ({ input }: { input: Record<string, unknown> }) =>
      toolDefinitionService.run({ provider, tool, input }, buId ? { bu_id: buId } : {}),
    // A test run calls the live tool exactly once; the app-wide retry would run it twice.
    retry: false,
  }));

export function useRunTool(provider: string, tool: string) {
  const buId = useAtomValue(selectedBusinessUnitIdAtom);
  const atom = useMemo(() => runToolMutationAtom(provider, tool, buId), [provider, tool, buId]);
  const [mutation] = useAtom(atom);
  return mutation;
}
